import { TaskCountPerPurpose } from '../store/types';

export const getTaskCount = (taskCountPerPurpose: TaskCountPerPurpose) =>
  Object.values(taskCountPerPurpose).reduce((totalCount, count) => totalCount + count || 0, 0);
